// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__97iuu","layoutContent":"Layout_layoutContent__sUSiX"};